const downloadFilePath = '/downloads/ExAdapter_Web_Setup_20200224.exe';
const downloadFileName = 'ExAdapter_Web_Setup_20200224.exe';

export function downloadJointCertificateProgram() {
  const element = document.createElement('a');
  element.href = downloadFilePath;
  element.download = downloadFileName;
  document.body.appendChild(element);
  element.click();
  element.remove();
}
